import { autoinject } from "aurelia-dependency-injection";
import { UserClientService } from "../basic/user-client.service";

@autoinject
export class AppcuesService {

    constructor(private userClientService: UserClientService) {}

    public identify(additionalMetadata?: any) {
        try {
            const user = this.userClientService.currentUser;

            if(!user) {
                return;
            }

            let metadata = {
                role: user.user.roleUsers[0].roleName, // Current user’s role or permissions
                firstName: user.user.firstName, // current user's first name
                lastName: user.user.lastName, // current user's last name
                companyName:  user?.businessUnit?.customerName ?? 'Rightship Internal', // Current user’s company name
                email: user.user.email
            };

            if(additionalMetadata) {
                metadata = {...metadata, ...additionalMetadata};
            }

            window["Appcues"]?.identify(user.user.id, metadata);
        }
        catch(e) {
            console.error(e);
        }
    }
}
